<template>
  <section
    class="testifying-to-man-used-by-holy-spirit-wrap"
    v-slide-up-in
    v-parallax
  >
    <v-page :background="theme.colors.cyan" v-slide-up-in-stage="1">
      <v-sub-chapter-index-page :pageData="pageDataItem.page0.data" />
    </v-page>

    <v-page>
      <v-text-content
        v-slide-up-in-stage="2"
        :isGodsWord="true"
        :html="pageDataItem.page1.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page2.data.content" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry class="margin0" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
    };
  },
  methods: {
    onCurrentUpdate(current) {
      this.current = current;
    },
  },
  created() {
    this.pageDataItem = this.schema[
      "testifying-to-man-used-by-Holy-Spirit"
    ].item;
  },
};
</script>
